
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"28","height":"28"}, attrs),
              ...rest,
            },
            children.concat([_c('image',{attrs:{"width":"28","height":"28","xlink:href":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAIGNIUk0AAHomAACAhAAA+gAAAIDo AAB1MAAA6mAAADqYAAAXcJy6UTwAAABjUExURQAAAP////////////////////////////////// /////9vg65KjxIudwMzU45mpyKi10MXO36GvzPj5+9Pa5/Hz9+Lm77fC2NTa5/j4+8XN36+81LbB 16i1z7fC16i20AAAAEdE/OAAAAAKdFJOUwBAj9/PnyAQkD+yeUh8AAAAAWJLR0QAiAUdSAAAAAlw SFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB+cMBAM5IlSlicsAAACvSURBVCjPlZLZDoMgFERHBLHU DW2xe///LytSKgq3Tc/ThJNJLskAExnL1QouCjhkqRIwOTuuknBrS0XAgEKRZBC0ZOC0zKG+sMh9 VTuahGw7PdNXQyQP9dEFU+tItqNP3aeKbTGsIioGVfjiyZg5nY25+IPfUts/XG262aRj2dt0J+TC H7JZy/VBw+MZMPqvbKYVwsFoKZDRcponWWW/pgmZ7LpRTxRi087Zzr6/ACtyIDshdn0eAAAAJXRF WHRkYXRlOmNyZWF0ZQAyMDIzLTEyLTA0VDAyOjMyOjE1KzAwOjAwk9+WzAAAACV0RVh0ZGF0ZTpt b2RpZnkAMjAyMy0xMi0wNFQwMjozMjoxNSswMDowMOKCLnAAAAAodEVYdGRhdGU6dGltZXN0YW1w ADIwMjMtMTItMDRUMDM6NTc6MzQrMDA6MDCCz9vkAAAAAElFTkSuQmCC"}})])
          )
        }
      }
    